import React from "react"
import {InnerWrapper, Wrapper} from "./styled"
import Letter from "./letter/Letter"
import LetterPanel from "./letterPanel/LetterPanel"



const Letters = ({letters}) => (
  <Wrapper>
    <InnerWrapper>
      {letters.map(letter=> (
        <Letter 
        key={letter.id} 
        positionX={letter.x}
        positionY={letter.y}
        letter={letter.l}
      />
      ))}
    </InnerWrapper>
    <LetterPanel letters={letters} />
  </Wrapper>
)

export default Letters